/* Express Delivery Variant IDs by Distance Tier */

// Default variants (used as fallback)
window.EXPRESS_VARIANTS = {
  tier1: 51840067305788,  // 0-10 km - $4.99
  tier2: 51840067338556,  // 10-20 km - $6.99
  tier3: 51840067371324,  // 20-30 km - $8.99
  tier4: 51840067404092   // 30-50 km - $12.99
};

// Store-specific variants mapping
window.EXPRESS_VARIANTS_BY_STORE = {
  // Smokey's 1hr Delivery (Virtual Store) - Edmonton
  "3782": {
    tier1: 51851020173628,  // 0-10 km - $4.99
    tier2: 51851020075324,  // 10-20 km - $6.99
    tier3: 51851020108092,  // 20-30 km - $8.99
    tier4: 51851020140860   // 30-50 km - $12.99
  },
  
  // Mill Creek - Edmonton
  "3781": {
    tier1: 51851019878716,  // 0-10 km - $4.99
    tier2: 51851019780412,  // 10-20 km - $6.99
    tier3: 51851019813180,  // 20-30 km - $8.99
    tier4: 51851019845948   // 30-50 km - $12.99
  },
  
  // Capilano - Edmonton
  "3779": {
    tier1: 51851020042556,  // 0-10 km - $4.99
    tier2: 51851019944252,  // 10-20 km - $6.99
    tier3: 51851019977020,  // 20-30 km - $8.99
    tier4: 51851020009788   // 30-50 km - $12.99
  }
};

// Helper function to get variants for current store
window.getExpressVariantsForStore = function(storeId) {
  // Ensure string comparison
  const id = String(storeId);
  
  // Return store-specific variants if available
  if (id && window.EXPRESS_VARIANTS_BY_STORE[id]) {
    return window.EXPRESS_VARIANTS_BY_STORE[id];
  }
  
  // Otherwise return default variants
  return window.EXPRESS_VARIANTS;
};

// Helper function to get price for distance (all stores use same pricing)
window.getExpressPriceForDistance = function(km, storeId) {
  if (km <= 10) return 4.99;
  if (km <= 20) return 6.99;
  if (km <= 30) return 8.99;
  return 12.99;
};